"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpecParserSource = exports.TeamsGraphScopes = exports.AzureScopes = exports.SPFxScopes = exports.ListSensitivityLabelScope = exports.GraphTeamsAppCatalogReadWriteScopes = exports.GraphTeamsInstallAppScopes = exports.GraphTeamsChannelReadScopes = exports.GraphTeamsTeamReadScopes = exports.GraphTeamsChannelCreateScopes = exports.GraphTeamsTeamCreateScopes = exports.GraphTeamsAppSettingsReadScopes = exports.GraphReadUserScopes = exports.GCScopes = exports.GroupSearchScopes = exports.GraphScopes = exports.MosServiceScope = exports.AppStudioScopes = exports.AuthSvcScopes = exports.serviceEndpoints = exports.ResourceServiceType = exports.OutlookClientId = exports.OfficeClientId = exports.TeamsClientId = exports.VSCodeExtensionCommand = exports.HelpLinks = exports.ConstantString = void 0;
exports.getAllowedAppMaps = getAllowedAppMaps;
exports.getResourceGroupInPortal = getResourceGroupInPortal;
exports.getResourceServiceEndpoint = getResourceServiceEndpoint;
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
const accountUtils_1 = require("./accountUtils");
const localizeUtils_1 = require("./localizeUtils");
class ConstantString {
    static UTF8Encoding = "utf-8";
    static DeploymentResourceType = "Microsoft.Resources/deployments";
    static DeploymentNotFound = "DeploymentNotFound";
    static RootFolder = "AgentsToolkitProjects";
}
exports.ConstantString = ConstantString;
class HelpLinks {
    static WhyNeedProvision = "https://aka.ms/teamsfx/whyneedprovision";
    static SwitchTenant = "https://aka.ms/teamsfx-switch-tenant";
}
exports.HelpLinks = HelpLinks;
class VSCodeExtensionCommand {
    static showOutputChannel = "command:fx-extension.showOutputChannel";
    static openFolder = "command:fx-extension.openFolder";
    static openReadme = "command:fx-extension.openReadMe?%5B%22Notification%22%5D";
}
exports.VSCodeExtensionCommand = VSCodeExtensionCommand;
class TeamsClientId {
    static MobileDesktop = "1fec8e78-bce4-4aaf-ab1b-5451cc387264";
    static Web = "5e3ce6c0-2b1f-4285-8d4b-75ee78787346";
}
exports.TeamsClientId = TeamsClientId;
class OfficeClientId {
    static Desktop = "0ec893e0-5785-4de6-99da-4ed124e5296c";
    static Web1 = "4345a7b9-9a63-4910-a426-35363201d503";
    static Web2 = "4765445b-32c6-49b0-83e6-1d93765276ca";
}
exports.OfficeClientId = OfficeClientId;
class OutlookClientId {
    static Desktop = "d3590ed6-52b3-4102-aeff-aad2292ab01c";
    static Web1 = "00000002-0000-0ff1-ce00-000000000000";
    static Web2 = "bc59ab01-8403-45c6-8796-ac3ef710b3e3";
    static Mobile = "27922004-5251-4030-b22d-91ecd9a37ea4";
}
exports.OutlookClientId = OutlookClientId;
function getAllowedAppMaps() {
    return {
        [TeamsClientId.MobileDesktop]: (0, localizeUtils_1.getLocalizedString)("core.common.TeamsMobileDesktopClientName"),
        [TeamsClientId.Web]: (0, localizeUtils_1.getLocalizedString)("core.common.TeamsWebClientName"),
        [OfficeClientId.Desktop]: (0, localizeUtils_1.getLocalizedString)("core.common.OfficeDesktopClientName"),
        [OfficeClientId.Web1]: (0, localizeUtils_1.getLocalizedString)("core.common.OfficeWebClientName1"),
        [OfficeClientId.Web2]: (0, localizeUtils_1.getLocalizedString)("core.common.OfficeWebClientName2"),
        [OutlookClientId.Desktop]: (0, localizeUtils_1.getLocalizedString)("core.common.OutlookDesktopClientName"),
        [OutlookClientId.Web1]: (0, localizeUtils_1.getLocalizedString)("core.common.OutlookWebClientName1"),
        [OutlookClientId.Web2]: (0, localizeUtils_1.getLocalizedString)("core.common.OutlookWebClientName2"),
    };
}
const AzurePortalUrl = "https://portal.azure.com";
function getResourceGroupInPortal(subscriptionId, tenantId, resourceGroupName) {
    if (subscriptionId && tenantId && resourceGroupName) {
        return `${AzurePortalUrl}/#@${tenantId}/resource/subscriptions/${subscriptionId}/resourceGroups/${resourceGroupName}`;
    }
    else {
        return undefined;
    }
}
var ResourceServiceType;
(function (ResourceServiceType) {
    ResourceServiceType["AuthSvc"] = "AuthSvc";
    ResourceServiceType["AuthSvcAud"] = "AuthSvcAud";
    ResourceServiceType["TDP"] = "TDP";
    ResourceServiceType["MOS3"] = "MOS3";
    ResourceServiceType["Graph"] = "Graph";
    ResourceServiceType["Azure"] = "Azure";
    ResourceServiceType["TeamsGraph"] = "TeamsGraph";
    ResourceServiceType["TeamsGraphAud"] = "TeamsGraphAud";
})(ResourceServiceType || (exports.ResourceServiceType = ResourceServiceType = {}));
exports.serviceEndpoints = {
    [accountUtils_1.SovereignCloudEnvironment.Public]: {
        [ResourceServiceType.AuthSvc]: "https://teams.microsoft.com/api/authsvc",
        [ResourceServiceType.AuthSvcAud]: "https://api.spaces.skype.com",
        [ResourceServiceType.TDP]: "https://dev.teams.microsoft.com",
        [ResourceServiceType.MOS3]: "https://titles.prod.mos.microsoft.com",
        [ResourceServiceType.Graph]: "https://graph.microsoft.com",
        [ResourceServiceType.Azure]: "https://management.azure.com",
        [ResourceServiceType.TeamsGraph]: "https://teams.microsoft.com/api/platform",
        [ResourceServiceType.TeamsGraphAud]: "https://teamsgraph.teams.microsoft.com",
    },
    [accountUtils_1.SovereignCloudEnvironment.GCCM]: {
        [ResourceServiceType.AuthSvc]: "https://teams.microsoft.com/api/authsvc",
        [ResourceServiceType.AuthSvcAud]: "https://api.spaces.skype.com",
        [ResourceServiceType.TDP]: "https://dev.teams.microsoft.com",
        [ResourceServiceType.MOS3]: "https://titles.gccm.mos.microsoft.com",
        [ResourceServiceType.Graph]: "https://graph.microsoft.com",
        [ResourceServiceType.Azure]: "https://management.azure.com",
        [ResourceServiceType.TeamsGraph]: "https://teams.microsoft.com/gcc/api/platform",
        [ResourceServiceType.TeamsGraphAud]: "https://teamsgraph.teams.microsoft.com",
    },
    [accountUtils_1.SovereignCloudEnvironment.GCCH]: {
        [ResourceServiceType.AuthSvc]: "https://authsvc.gov.teams.microsoft.us",
        [ResourceServiceType.AuthSvcAud]: "https://authsvc.teams.microsoft.com",
        [ResourceServiceType.TDP]: "https://gov.dev.teams.microsoft.us",
        [ResourceServiceType.MOS3]: "https://titles.gcch.mos.svc.usgovcloud.microsoft",
        [ResourceServiceType.Graph]: "https://graph.microsoft.us",
        [ResourceServiceType.Azure]: "https://management.usgovcloudapi.net",
        [ResourceServiceType.TeamsGraph]: "https://gov.teams.microsoft.us/api/platform",
        [ResourceServiceType.TeamsGraphAud]: "https://teamsgraph.gov.teams.microsoft.us",
    },
    [accountUtils_1.SovereignCloudEnvironment.DOD]: {
        [ResourceServiceType.AuthSvc]: "https://authsvc.dod.teams.microsoft.us",
        [ResourceServiceType.AuthSvcAud]: "https://authsvc.teams.microsoft.com",
        [ResourceServiceType.TDP]: "https://dod.dev.teams.microsoft.us",
        [ResourceServiceType.MOS3]: "https://titles.dod.mos.svc.usgovcloud.microsoft",
        [ResourceServiceType.Graph]: "https://dod-graph.microsoft.us",
        [ResourceServiceType.Azure]: "https://management.usgovcloudapi.net",
        [ResourceServiceType.TeamsGraph]: "https://dod.teams.microsoft.us/api/platform",
        [ResourceServiceType.TeamsGraphAud]: "https://teamsgraph.dod.teams.microsoft.us",
    },
};
function getResourceServiceEndpoint(resourceServiceType) {
    if (resourceServiceType === ResourceServiceType.TDP &&
        process.env.APP_STUDIO_ENV &&
        process.env.APP_STUDIO_ENV === "int") {
        return "https://dev-int.teams.microsoft.com";
    }
    const sovereignCloudEnvironment = (0, accountUtils_1.getSovereignCloudEnvironment)();
    return exports.serviceEndpoints[sovereignCloudEnvironment][resourceServiceType];
}
// AuthSvc
const AuthSvcScopes = () => {
    return [`${getResourceServiceEndpoint(ResourceServiceType.AuthSvcAud)}/Region.ReadWrite`];
};
exports.AuthSvcScopes = AuthSvcScopes;
// TDP
const AppStudioScopes = () => {
    return [`${getResourceServiceEndpoint(ResourceServiceType.TDP)}/AppDefinitions.ReadWrite`];
};
exports.AppStudioScopes = AppStudioScopes;
// MOS3
const MosServiceScope = () => {
    return [`${getResourceServiceEndpoint(ResourceServiceType.MOS3)}/.default`];
};
exports.MosServiceScope = MosServiceScope;
// Graph
exports.GraphScopes = ["Application.ReadWrite.All", "TeamsAppInstallation.ReadForUser"];
exports.GroupSearchScopes = ["GroupMember.Read.All"];
exports.GCScopes = ["ExternalConnection.Read.All"];
exports.GraphReadUserScopes = ["User.ReadBasic.All"];
exports.GraphTeamsAppSettingsReadScopes = ["TeamworkAppSettings.Read.All"];
exports.GraphTeamsTeamCreateScopes = ["Team.Create"];
exports.GraphTeamsChannelCreateScopes = ["Channel.Create"];
exports.GraphTeamsTeamReadScopes = ["Team.ReadBasic.All"];
exports.GraphTeamsChannelReadScopes = ["Channel.ReadBasic.All"];
exports.GraphTeamsInstallAppScopes = ["TeamsAppInstallation.ReadWriteAndConsentForTeam"];
exports.GraphTeamsAppCatalogReadWriteScopes = ["AppCatalog.ReadWrite.All"];
exports.ListSensitivityLabelScope = "InformationProtectionPolicy.Read";
// SPFx
const SPFxScopes = (tenant) => [`${tenant}/Sites.FullControl.All`];
exports.SPFxScopes = SPFxScopes;
// Azure
const AzureScopes = () => {
    return [`${getResourceServiceEndpoint(ResourceServiceType.Azure)}/.default`];
};
exports.AzureScopes = AzureScopes;
const TeamsGraphScopes = () => {
    return [`${getResourceServiceEndpoint(ResourceServiceType.TeamsGraphAud)}/.default`];
};
exports.TeamsGraphScopes = TeamsGraphScopes;
exports.SpecParserSource = "SpecParser";
//# sourceMappingURL=constants.js.map